import { render } from "./CapitalCardLoader.vue?vue&type=template&id=5a0f0966&scoped=true"
import script from "./CapitalCardLoader.vue?vue&type=script&lang=js"
export * from "./CapitalCardLoader.vue?vue&type=script&lang=js"

import "./CapitalCardLoader.vue?vue&type=style&index=0&id=5a0f0966&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0f0966"]])

export default __exports__